import React from "react";
import { Popconfirm } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./../styled/screen.styled";

type IConfirm = {
  handleOnConfirm: (...args: any[]) => void;
  okText: string;
  cancelText: string;
  disabled: boolean;
};

type IConfirmViewEdit = {
  okText: string;
  cancelText: string;
  handleOnConfirm: (...args: any[]) => void;
};

export const ConfirmViewEdit = ({ handleOnConfirm, okText, cancelText }: IConfirmViewEdit) => (
  <Popconfirm title={useTranslation({ id: "save_edit" })} placement="leftBottom" onConfirm={handleOnConfirm} onCancel={() => false} okText={okText} cancelText={cancelText}>
    <S.RegisterButton type="primary" id="drawer-view-edit" htmlType="submit">
      {useTranslation({ id: "save" })}
    </S.RegisterButton>
  </Popconfirm>
);

export const ConfirmInbound = ({ handleOnConfirm, okText, cancelText, disabled }: IConfirm) => (
  <Popconfirm
    title={useTranslation({ id: "message_check_out_the_vehicle" })}
    placement="leftBottom"
    onConfirm={handleOnConfirm}
    onCancel={() => false}
    okText={okText}
    cancelText={cancelText}
    disabled={disabled}
  >
    <S.RegisterButton type="primary" id="drawer-outbound" htmlType="submit" disabled={disabled} loading={disabled}>
      {useTranslation({ id: "register" })}
    </S.RegisterButton>
  </Popconfirm>
);

export const ConfirmCancelEdit = ({ handleOnConfirm, okText, cancelText, disabled }: IConfirm) => (
  <Popconfirm title={useTranslation({ id: "cancel_edit" })} placement="rightBottom" onConfirm={handleOnConfirm} onCancel={() => false} okText={okText} cancelText={cancelText}>
    <S.CancelButton htmlType="submit" id="drawer-cancel-edit" disabled={disabled}>
      {useTranslation({ id: "cancel" })}
    </S.CancelButton>
  </Popconfirm>
);
